{
  "zitate": [
    {
      "position": "nach-medienprojekte",
      "text": "„Zachor“- erinnere dich.<br> Ein Gebot aus der Tora, ein Teil jüdischen Lebens. Erinnern geschieht oft spontan.<br> „Tarbut“ – Kultur – das pflegt man täglich.<br> Erinnerungskultur ist: gepflegte Spontanität.",
      "autor": "Yuriy Kadnykov",
      "funktion": "Landesrabbiner",
      "bild": "img/zitate/kadnykov.webp"
    },
    {
      "position": "nach-filmproduktionen",
      "text": "Jüdische Geschichte sichtbar zu machen, heißt, junge Menschen für die Gefahren von Ausgrenzung zu sensibilisieren – und sie zu stärken im Einsatz für Vielfalt, Menschlichkeit und Demokratie.",
      "autor": "Magdalena Kunert",
      "funktion": "Projektleiterin",
      "bild": "img/zitate/kunert.webp"
    },
    {
      "position": "nach-ueber-uns",
      "text": "Erinnerungskultur macht vergangenes Unrecht sichtbar, führt uns die Gefahren von Antisemitismus vor Augen und stärkt unser Bewusstsein für demokratische Werte sowie deren Bewahrung und Verteidigung. Für Greifswald und gerade auch für junge Menschen ist es bedeutsam und hilfreich, wenn auch hier Orte und Ereignisse jüdischen Lebens sichtbar gemacht werden, weil damit Geschichte bewahrt und eine wertvolle Orientierung für die Zukunft gegeben werden kann.",
      "autor": "Dr. Stefan Fassbinder",
      "funktion": "Oberbürgermeister Greifswald",
      "bild": "img/zitate/fassbinder.webp"
    },
    {
      "position": "nach-begleitmaterial",
      "text": "Geschichte ist nie abstrakt, sondern wird lebendig in den persönlichen Biographien. Die Auseinandersetzung mit konkreten Lebensgeschichten jüdischer Menschen ist die beste Medizin gegen Antisemitismus. Ich wünsche mir eine junge Generation, die wach ist für die Lebens- und Leidenswege, die Greifswalder Jüdinnen und Juden gegangen sind.",
      "autor": "Nicolaus Voss",
      "funktion": "Beauftragter gegen Antisemitismus MV",
      "bild": "img/zitate/voss.webp"
    },
    {
      "position": "nach-gedenkort",
      "text": "Medienbildung hilft jungen Menschen, unsere Geschichte zu verstehen und sich aktiv dafür einzusetzen, dass der jüdische Friedhof in der Gützkower Landstraße wieder Teil der Erinnerungskultur unserer Stadt wird.",
      "autor": "Roland Rosenstock",
      "funktion": "Professor für Religions- und Medienpädagogik",
      "bild": "img/zitate/rosenstock.webp"
    },
    {
      "position": "nach-stolpersteine-app",
      "text": "Es ist uns ein Anliegen, das große ehrenamtliche Engagement, welches sich in Greifswald mit den Stolpersteinen verbindet, sichtbarer und zugänglicher zu machen.",
      "autor": "Jochen Schmidt",
      "funktion": "Direktor der Landeszentrale für politische Bildung M-V",
      "bild": "img/zitate/schmidt.webp"
    }
  ]
}
